const WranggleRpcRegistryAttrib = '__rpcTransportShortcuts__';
export function registerTransport(transportType, transportFactory) {
    getTransportRegistry()[transportType] = transportFactory;
}
export function getKnownTransportTypes() {
    return Object.keys(getTransportRegistry());
}
// Was thinking to keep the shortcut registration data in a required module's private variable, but having trouble with dist vs src imports (mainly with tests)
// So leaving it on global for now, until that shakes out. note: can be changed easily later because the shortcut registration is internal and occurs before construction.
export function getTransportRegistry() {
    // @ts-ignore
    global[WranggleRpcRegistryAttrib] = global[WranggleRpcRegistryAttrib] || {};
    // @ts-ignore
    return global[WranggleRpcRegistryAttrib];
}
//# sourceMappingURL=transport-shortcut-registration.js.map